import './calculator.css';

export default function Calculator() {
    return(
        <div className="cut-calc">
            <p>caluator section</p>
        </div>
    )
}